import React, { useState } from 'react';
import './modal.css';

const defaultLayer = {
  layer_name: '',
  datatype_name: '',
  layer_number: '',
  datatype_number: '',
  color: '#ffffff',
  opacity: 0.5,
};

const NewLayerModal = ({ onClose, onSave }) => {
  const [form, setForm] = useState(defaultLayer);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === 'opacity' ? parseFloat(value) : value,
    }));
  };

  const handleSubmit = () => {
    const { layer_name, datatype_name, layer_number, datatype_number, color, opacity } = form;

    if (!layer_name || !datatype_name || !layer_number || !datatype_number) {
      alert("All fields are required.");
      return;
    }

    // 🧠 Final layer object with hardcoded values
    const newLayer = {
      layer_name,
      datatype_name,
      layer_number,
      datatype_number,
      color,
      pattern: { type: "vertical_lines", opacity },
      outline: { type: "solid", width: "2px" },
      editable: true
    };

    onSave(newLayer);
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h3 style={{ marginBottom: '8px' }}>Add New Layer</h3>

        <input name="layer_name" placeholder="Layer Name" value={form.layer_name} onChange={handleChange} />
        <input name="datatype_name" placeholder="Datatype Name" value={form.datatype_name} onChange={handleChange} />
        <input name="layer_number" placeholder="Layer #" type="number" value={form.layer_number} onChange={handleChange} />
        <input name="datatype_number" placeholder="Datatype #" type="number" value={form.datatype_number} onChange={handleChange} />
        <label style={{ fontSize: '12px', marginTop: '5px' }}>Color</label>
        <input name="color" type="color" value={form.color} onChange={handleChange} />

        <label style={{ fontSize: '12px', marginTop: '10px' }}>Pattern Opacity: {form.opacity}</label>
        <input
          name="opacity"
          type="range"
          min="0.1"
          max="1"
          step="0.1"
          value={form.opacity}
          onChange={handleChange}
        />

        <div className="modal-actions">
          <button onClick={handleSubmit}>Save</button>
          <button onClick={onClose} style={{ backgroundColor: 'gray' }}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default NewLayerModal;
